import { COMMON_EVENT_NAMES } from "../../constants";

export const EVENT_NAME = {
  CLICK_LINK: COMMON_EVENT_NAMES.NAVIGATED
};
